'use es6';

import Raven from 'raven-js';
import { bundleVersion, utk, parentUrl } from './environment';
import { portalId } from '../popupInjector/environment';
Raven.setTagsContext({
  bundleVersion,
  parentUrl,
  portalId,
  utk
});